/**
 * Lista os contatos de suporte técnico (não-emergencial) por empresa — GUPM-200.
 * Alimenta o bloco de suporte da sub-aba "Contatos" da aba Outros.
 *
 * Regra #2: leitura via datasource `contatos`, nunca `supabase.from` na UI.
 * `contacts` é 🟠 sensível — RLS garante leitura só a autenticado. O diretório é
 * de quem tem empresa (GUPM-202); quem também é de emergência aparece nos dois.
 */
import { useQuery } from '@tanstack/react-query';
import { useDataSources } from '@/services/datasources';

/** `habilitado = false` evita a consulta (a aba Contatos do admin lê tudo de `listParaGestao`, C-75). */
export function useSuporteTecnico(habilitado = true) {
  const { contatos } = useDataSources();
  return useQuery({
    queryKey: ['contatos', 'suporte-tecnico'],
    enabled: habilitado,
    staleTime: 30 * 60 * 1000,
    queryFn: () => contatos.listSuporteTecnico(),
  });
}
